import service from "../services/BannersService";
import Banner from "@p1s/p1s-common-react/entities/Banner";

export default new class BannersApi {
    getBanners () {
        return new Promise((resolve, reject) => {
            service.getBanners()
                .then(res => resolve(convertJsonToBanners(res.data)))
                .catch((err) => reject(err));
        });
    }
};

const convertJsonToBanners = (json) => {
    let announcements = [];
    if (json && json.length > 0) {
        announcements = json.map((p) => new Banner(p));
    }
    return announcements;
};

